import React from 'react';
import { SUBSCRIBER_PATH } from '../../../../constants';

const MyCertificatesOfCompletion = React.lazy(() => import('./index'));

const Routes = {
     path: SUBSCRIBER_PATH.MY_CE_OF_COMPLETION,
     breadcrumb: 'My Training Certificates of Training',
     fetch: true,
     element: <MyCertificatesOfCompletion />,
};

export default Routes;
